// extracted by mini-css-extract-plugin
export var dividerLine = "_5n-0";
export var errorBackground = "_5n-1";